import {StrMap} from "../pages/interfaces/category_interfaces.ts";

export const languageMap:StrMap = {
  "en": "English",
  "sv": "Swedish",
  "da": "Danish",
  "fi": "Finnish",
  "no": "Norwegian",
  "de": "German",
  "fr": "French",
  "it": "Italian",
  "es": "Spanish",
}

export const surveyLanguages:Array<string> = [
  "en",
  "sv",
  "da",
  "fi",
  "no",
  "de",
  "fr",
  "it",
  "es"
]